import { render } from "./Calcolatore.vue?vue&type=template&id=1d602fe6&bindings={\"disclaimer\":\"props\",\"availableServices\":\"options\",\"calcParams\":\"options\",\"applicableThreshold\":\"options\",\"afterGiacenza\":\"options\",\"toggleModal\":\"options\",\"calculate\":\"options\",\"onlyNumber\":\"options\"}"
import script from "./Calcolatore.vue?vue&type=script&lang=js"
export * from "./Calcolatore.vue?vue&type=script&lang=js"

import "./Calcolatore.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script